(() => {
  function diameter(title) {
    const value = String(title).toUpperCase().trim();
    const match = value.match(/(?:\d{3}(?:\/\d{2,3})?|\d{2}(?:\.\d+)?X\d{1,4}(?:\.\d+)?)\s*(?:ZR|R|D|-)\s*(\d{2}(?:\.5)?)(?=LT|C|\D|$)/);
    return match ? Number(match[1]) : null;
  }

  class TireSizes extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const picker = document.getElementById(this.dataset.picker);
      const selects = picker?.querySelectorAll('select');
      if (selects?.length !== 1) return;
      const select = selects[0];
      const options = [...select.options];
      if (!options.some(option => diameter(option.value))) return;
      let variants;
      try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (_) { return; }
      let inventory = {live: false, variants: []};
      try { inventory = JSON.parse(this.querySelector('.njt-tires__inventory').textContent); } catch (_) {}
      this.ready = true;
      const section = picker.closest('section') || picker.parentElement;
      const incomingVariant = new URL(location.href).searchParams.get('variant');
      let hasChosenSize = variants.some(variant => String(variant.id) === incomingVariant);
      const form = select.form || section.querySelector('product-form form, form[id^="product-form-"]');
      const addButton = form?.querySelector('[name="add"]');
      const addLabel = addButton?.querySelector('span');
      const originalAddLabel = addLabel?.textContent;
      const currency = this.dataset.currency || 'CAD';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency, currencyDisplay: 'narrowSymbol'});
      const priceLabel = variant => `${money.format(variant.price / 100)} ${currency} ${this.dataset.perTire}`;
      const availability = variant => {
        const stock = inventory.variants.find(item => String(item.id) === String(variant.id));
        if (!variant.available) return {label: this.dataset.outStock, state: 'out'};
        if (inventory.live && stock?.tracked && Number.isFinite(stock.quantity)) {
          if (stock.quantity > 0) return {label: this.dataset.stockCount.replace('__COUNT__', stock.quantity >= 50 ? '50+' : stock.quantity), state: 'in'};
          return {label: this.dataset.noStockOrder, state: 'order'};
        }
        return {label: this.dataset.availableOrder, state: 'order'};
      };
      const outer = document.createElement('details');
      outer.className = 'njt-tires__dropdown';
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.textContent = this.dataset.label;
      label.className = 'njt-tires__label';
      const current = document.createElement('strong');
      current.className = 'njt-tires__current';
      summary.append(label, current);
      outer.append(summary);
      const list = document.createElement('div');
      list.className = 'njt-tires__groups';
      const groups = new Map();
      options.forEach(option => {
        const key = diameter(option.value);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(option);
      });
      const buttons = [];
      const details = [];
      [...groups.keys()].sort((a, b) => (a ?? Infinity) - (b ?? Infinity)).forEach(key => {
        const group = document.createElement('details');
        group.className = 'njt-tires__group';
        const heading = document.createElement('summary');
        const groupOptions = groups.get(key);
        heading.textContent = `${key === null ? this.dataset.other : `${key}\"`} - ${groupOptions.length} ${groupOptions.length === 1 ? this.dataset.one : this.dataset.many}`;
        group.append(heading);
        groupOptions.sort((a, b) => a.value.localeCompare(b.value, undefined, {numeric: true})).forEach(option => {
          const variant = variants.find(item => item.options[0] === option.value);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'njt-tires__size';
          button.dataset.value = option.value;
          const title = document.createElement('span');
          title.textContent = option.value;
          const meta = document.createElement('span');
          meta.className = 'njt-tires__meta';
          if (variant) {
            const price = document.createElement('span');
            price.className = 'njt-tires__price';
            price.textContent = priceLabel(variant);
            meta.append(price);
            const stock = document.createElement('span');
            const status = availability(variant);
            stock.className = 'njt-tires__stock';
            stock.dataset.stock = status.state;
            stock.textContent = status.label;
            meta.append(stock);
          }
          const state = document.createElement('span');
          state.className = 'njt-tires__selected';
          state.textContent = this.dataset.selected;
          meta.append(state);
          button.append(title, meta);
          button.addEventListener('click', () => {
            hasChosenSize = true;
            select.value = option.value;
            select.dispatchEvent(new Event('change', {bubbles: true}));
            sync();
            details.forEach(group => { group.open = false; });
            outer.open = false;
            list.scrollTop = 0;
            summary.focus({preventScroll: true});
            if (window.matchMedia?.('(max-width: 749px)').matches) {
              requestAnimationFrame(() => {
                const header = document.querySelector('.section-header');
                summary.style.scrollMarginTop = ((header?.getBoundingClientRect().height || 0) + 16) + 'px';
                summary.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
              });
            }
          });
          buttons.push({button, state, group});
          group.append(button);
        });
        group.addEventListener('toggle', () => {
          if (group.open) details.forEach(other => { if (other !== group) other.open = false; });
        });
        details.push(group);
        list.append(group);
      });
      const note = document.createElement('p');
      note.className = 'njt-tires__note';
      note.textContent = this.dataset.note;
      outer.append(list);
      outer.addEventListener('toggle', () => {
        if (!outer.open) {
          details.forEach(group => { group.open = false; });
          list.scrollTop = 0;
        }
      });
      this.append(outer, note);
      const sync = () => {
        current.textContent = hasChosenSize ? select.value : '';
        current.hidden = !hasChosenSize;
        section.classList.toggle('njt-tires-awaiting-size', !hasChosenSize);
        if (addLabel) addLabel.textContent = hasChosenSize ? originalAddLabel : this.dataset.label;
        const variant = variants.find(item => item.options[0] === select.value);
        section.querySelectorAll('[data-tire-purchase-summary]').forEach(box => {
          const size = box.querySelector('[data-tire-purchase-size]');
          const price = box.querySelector('[data-tire-purchase-price]');
          box.hidden = !hasChosenSize;
          if (size) size.textContent = hasChosenSize ? select.value : '';
          if (price) price.textContent = hasChosenSize && variant ? priceLabel(variant) : '';
        });
        buttons.forEach(({button, state, group}) => {
          const selected = hasChosenSize && button.dataset.value === select.value;
          button.setAttribute('aria-pressed', String(selected));
          state.hidden = !selected;
        });
      };
      const requireSize = event => {
        if (hasChosenSize) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        outer.open = true;
        summary.focus({preventScroll: true});
        summary.scrollIntoView({block: 'nearest', behavior: 'instant'});
      };
      form?.addEventListener('submit', requireSize, true);
      addButton?.addEventListener('click', requireSize, true);
      select.addEventListener('change', () => { hasChosenSize = true; sync(); });
      sync();
      select.closest('.product-form__input').hidden = true;
      select.closest('.product-form__input').classList.add('njt-tires__native');
      this.hidden = false;
    }
  }
  if (typeof customElements !== 'undefined' && !customElements.get('njt-tire-sizes')) customElements.define('njt-tire-sizes', TireSizes);
})();
